var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import DefaultComparer from '../system/DefaultComparer';
import DefaultEqualityComparer from '../system/DefaultEqualityComparer';
import NumberUtils from '../primitives/NumberUtils';
export default class ArrayUtils {
    static equal(array1, array2, equalityComparer = DefaultEqualityComparer.equal) {
        if (array1.length !== array2.length) {
            return false;
        }
        for (let i = 0; i < array1.length; i++) {
            const result = equalityComparer(array1[i], array2[i]);
            if (result !== true) {
                return false;
            }
        }
        return true;
    }
    ;
    static compare(array1, array2, comparer = DefaultComparer.compare) {
        if (array1.length !== array2.length) {
            return NumberUtils.compare(array1.length, array2.length);
        }
        for (let i = 0; i < array1.length; i++) {
            const result = comparer(array1[i], array2[i]);
            if (result !== 0) {
                return result;
            }
        }
        return 0;
    }
    ;
    static fromAsyncIterable(iterable) {
        var iterable_1, iterable_1_1;
        var e_1, _a;
        return __awaiter(this, void 0, void 0, function* () {
            const out = [];
            try {
                for (iterable_1 = __asyncValues(iterable); iterable_1_1 = yield iterable_1.next(), !iterable_1_1.done;) {
                    const x = iterable_1_1.value;
                    out.push(x);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) yield _a.call(iterable_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return out;
        });
    }
    ;
    static fromValue(value, length) {
        return new Array(length).fill(value);
    }
    ;
    static fromRange(start, end, step = 1) {
        const values = [];
        for (let i = start; i <= end; i += step) {
            values.push(i);
        }
        return values;
    }
    ;
    static isNullOrEmpty(obj) {
        if (obj === null || obj === undefined) {
            return true;
        }
        else {
            return obj.length === 0;
        }
    }
}
//# sourceMappingURL=ArrayUtils.js.map